import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { RootScopeService } from '../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../core/rootscope-declare';
import { environment } from '../../../../environments/environment';
import { FacilityDetailsService } from '../../services/facility-details.service';
import { FacilityService } from '../../../core/services/facility.service';
import { FacilityObject } from '../../../core/services/facility.model';
import { Subscription } from 'rxjs';
import { SubscriptionService } from '../../services/subscription.service';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-subscription-announcement-modal',
  templateUrl: './subscription-announcement-modal.component.html',
  styleUrls: ['./subscription-announcement-modal.component.scss'],
})
export class SubscriptionAnnouncementModalComponent implements OnInit, OnDestroy {
  // subscriptions
  private _facilityOnChange: Subscription;

  currentFacility: FacilityObject;
  cloudBasePath: string;
  rootScopeData: RootScopeDeclare;

  @Output() onClose: EventEmitter<string> = new EventEmitter();

  constructor(
    private rootScopeService: RootScopeService,
    private facilityDetailService: FacilityDetailsService,
    private _facilityService: FacilityService,
    private _subscriptionService: SubscriptionService,
    private _amplitudeAnalytics: AmplitudeAnalyticsService,
    private _loader: HaloLoaderService
  ) {}

  ngOnInit(): void {
    this.cloudBasePath = environment.cloudBasePath;
    this.getRootScopeData();

    // subscript facility change / when facility change
    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe((res) => {
      this.currentFacility = res;
    });
  }

  ngOnDestroy() {
    // destroy subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => {
      this.rootScopeData = rootScopeData;
    });
  }

  updateHideSubscriptionModal(goToScreen: string) {
    const inputJson: any = {};
    inputJson.showSubscriptionPopup = 'false';
    if (goToScreen === 'viewSubscriptions') {
      //added the below line of code so that banner will appear for the facility for which the user has got the overall subscription portal announcement
      this._facilityService
        .setFacilityUserPreference('isSubscriptionBannerEnabled', false)
        .then()
        .finally(() => {
          this._subscriptionService.getToken();
          this.onClose.emit('subscriptionModal');
          this._loader.endProcess();
        });
    } else {
      this.onClose.emit('subscriptionModal');
    }
  }
}
